export const blockIconsAudioandvideoLoop = (
	<span className='material-symbols-outlined'>loop</span>
);
